import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import constants from "../../config/constants.json";
import { isEmpty, isNil } from "lodash";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import styles from './common.module.scss';

interface errorComponentProps {
  headerTitle?: string;
  showMessage?: string;
  // extraMessage?: string;
  isOpen?: boolean;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  // onCreditClick?: () => void;
  // showCloseButton?: boolean;
}

const ErrorPopup = (props: errorComponentProps) => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, constants.TOAST_POPUP_DURATION);

    return () => clearTimeout(timer);
  }, [isOpen]);

  const getErrorMessage = (): string => {
    var message = "";
    if (isNil(props.showMessage) || isEmpty(props.showMessage)) {
      message = "Sorry! Error Occurred, Please try again later.";
    } else {
      message = props.showMessage;
    }
    return message;
  };

  const handleClose = (): void => {
    setIsOpen(false);
    props?.setIsOpen?.(false);
    toast.remove();
  };

  return (
    <>
      <div>
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              margin: "32px",
              borderRadius: "16px",
              background: "#FFF",
              maxHeight: "auto",
              maxWidth: "100%",
              width: "730px",
              flexDirection: "column",
            },
          }}
        >
          <div className={styles.ErrorMessageContainer}>
            <DialogTitle className={styles.ErrorMessageTitle}>
              {props.headerTitle ? "Attention" : "Error Message"}
            </DialogTitle>
            <IconButton
            id="closeButton"
              aria-label="close"
              onClick={handleClose}
              sx={{
                float: "right",
                color: "#fff",
                padding: "20px",
                marginLeft: "auto",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent className={styles.ErrorMessageDiagloContent}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "30px",
            }}
          >
            {props.headerTitle != "Attention" ?
              <img
                src="/images/ErrorPopup.svg"
                style={{
                  margin: "2px",
                  alignItems: "center",
                  height: "50px",
                  width: "50px",
                }}
              /> :
              <div style={{ backgroundColor: "#FEBE00", padding: "10px", height: "50px", width: "50px", borderRadius: "50%" }}>
                <WarningAmberOutlinedIcon sx={{
                  color: "#fff",
                  margin: "2px",
                  alignItems: "center",
                  fontSize: "40px",
                  marginLeft: "5px"
                }} />
              </div>
            }
            <Typography className={styles.ErrorMessageContent}>
              {/* {"Sorry! Error Occurred, Please try again later."}
                <br/> */}
              {getErrorMessage()}
            </Typography>
            {/* <div
                style={{
                  textAlign: "center",
                  textDecoration: "underline",
                  fontFamily: "Lato",
                  color: "#f05802",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <div onClick={props?.onCreditClick}>{props?.extraMessage}</div>
              </div> */}
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default ErrorPopup;
